// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Config from "../../../../../Config.bs.js";
import * as CommonErrorCmp from "../../../../../common/components/error-cmp/components/CommonErrorCmp.bs.js";
import * as N_RnrApiHelper from "../../../domain/data-machine/N_RnrApiHelper.bs.js";
import * as N_RnrStateMachine from "../../state-manager/N_RnrStateMachine.bs.js";
import * as Languages$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/entities/vernacular/Languages.bs.js";
import * as N_RnrLazyWrapperCmp from "../N_RnrLazyWrapperCmp.bs.js";
import * as RnrDashboardWrapper from "../../../../rnr/components/RnrDashboardWrapper.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";

function N_RnrConfigLoaderCmp(Props) {
  var uuid = Props.uuid;
  var auth_token = Props.auth_token;
  var language = Props.language;
  var version = Props.version;
  var version_code = Props.version_code;
  var match = React.useReducer(N_RnrStateMachine.reducer, N_RnrStateMachine.initialState);
  var dispatch = match[1];
  React.useEffect((function () {
          N_RnrApiHelper.fetchRnrConfigApiCall(uuid, auth_token, dispatch);
          
        }), []);
  var config_data = match[0].config;
  if (typeof config_data === "number") {
    return null;
  }
  switch (config_data.TAG | 0) {
    case /* Loading */0 :
        return React.createElement(CircularLoader$Catalyst.make, {});
    case /* Live */1 :
        var match$1 = config_data._0.vehicle_category;
        var match$2 = Config.Env.is2wCampaignEnabled(undefined);
        if (match$1 === "2_wheeler" && match$2) {
          return React.createElement(N_RnrLazyWrapperCmp.make, {
                      uuid: uuid,
                      auth_token: auth_token,
                      language: Languages$Catalyst.fromCode(language),
                      version: version,
                      version_code: version_code
                    });
        }
        return React.createElement(RnrDashboardWrapper.make, {
                    uuid: uuid,
                    authToken: auth_token,
                    language: language,
                    version: version,
                    version_code: version_code
                  });
    case /* Error */2 :
        return React.createElement(CommonErrorCmp.make, {
                    reload_cb: (function (param) {
                        return N_RnrApiHelper.fetchRnrConfigApiCall(uuid, auth_token, dispatch);
                      })
                  });
    
  }
}

var make = N_RnrConfigLoaderCmp;

export {
  make ,
  
}
/* react Not a pure module */
